import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { Button, type ButtonProps } from '@mui/material';

const StyledButton = styled(Button)(
  ({ theme }) => ({
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.action.hover,
    ':hover': {
      backgroundColor: theme.palette.action.selected,
    },
  }),
  addBorderInHighContrastMode,
  addHighContrastStyles(({ theme }) => {
    if (!theme.isDark) {
      return null;
    }

    return {
      backgroundColor: 'black',
      ':hover': {
        backgroundColor: 'transparent',
      },
    };
  }),
);

const TonalButton = <T extends React.ElementType = 'button'>(
  props: ButtonProps<T>,
) => <StyledButton {...props} />;

export default TonalButton;
